module.exports = __webpack_public_path__ + "static/media/22ESCWA9.3a962736.jpg";